import React, { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Textarea } from "@/components/ui/textarea";

const CSATRCPractice = ({ isPro, onBack, onSolveRC }) => {
  const [rcPassage, setRcPassage] = useState("");

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-6xl mx-auto px-6 py-12 space-y-8">
        <div className="flex items-center justify-between">
          <Button variant="outline" className="border-slate-200" onClick={onBack}>← Back to CSAT Suite</Button>
          <Badge variant="outline" className={`px-4 py-2 text-sm ${isPro ? 'border-slate-900 text-slate-900' : 'border-slate-300 text-slate-500'}`}>{isPro ? "PRO" : "FREE"}</Badge>
        </div>

        {/* Header - CLARIAS Style */}
        <div className="pb-6 border-b border-slate-100">
          <h1 className="text-2xl font-semibold text-slate-900">RC Practice</h1>
          <p className="text-slate-500">
            Reading Comprehension = Safest Scoring Zone (PYQ-Proven)
          </p>
        </div>

        {/* RC Strategy Card - CLARIAS Style */}
        <Card className="border-slate-200 bg-slate-50/50">
          <CardContent className="p-5">
            <h3 className="text-sm font-medium text-slate-700 mb-4">RC Mastery Strategy</h3>
            <div className="grid md:grid-cols-4 gap-3">
              <div className="bg-white rounded-lg p-3 border border-slate-200">
                <p className="text-xs font-medium text-slate-800 mb-1">Passage Diagnosis</p>
                <p className="text-[11px] text-slate-500">Central idea, Author&apos;s intent, Tone, Scope limits</p>
              </div>
              <div className="bg-white rounded-lg p-3 border border-slate-200">
                <p className="text-xs font-medium text-slate-800 mb-1">Option Elimination</p>
                <p className="text-[11px] text-slate-500">Remove extremes, outside-scope, distorted inferences</p>
              </div>
              <div className="bg-white rounded-lg p-3 border border-slate-200">
                <p className="text-xs font-medium text-slate-800 mb-1">Second-Best Trap</p>
                <p className="text-[11px] text-slate-500">Why the tempting option is wrong (PYQ logic)</p>
              </div>
              <div className="bg-white rounded-lg p-3 border border-slate-200">
                <p className="text-xs font-medium text-slate-800 mb-1">Topper Mindset</p>
                <p className="text-[11px] text-slate-500">One-line topper approach for each question</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="border-slate-200 bg-white">
          <CardContent className="p-6 space-y-4">
            <div className="space-y-3">
              <label className="text-sm font-medium text-slate-700">Paste RC Passage & Question</label>
              <Textarea
                rows={10}
                value={rcPassage}
                onChange={(e) => setRcPassage(e.target.value)}
                placeholder="Paste the RC passage followed by the question and options..."
                className="text-sm resize-none border-2 focus:border-slate-400"
              />
            </div>

            <Button
              onClick={() => onSolveRC(rcPassage)}
              disabled={!rcPassage.trim()}
              className="w-full bg-slate-900 hover:bg-slate-800 text-white font-medium py-3"
            >
              Analyze RC
            </Button>
          </CardContent>
        </Card>

        {/* RC Tips - CLARIAS Style */}
        <Card className="border-slate-200">
          <CardContent className="p-6">
            <h3 className="text-base font-medium text-slate-900 mb-4">RC Quick Tips</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-green-50 border-l-4 border-green-500 p-3">
                <p className="text-sm text-green-800">
                  <span className="font-semibold">Do:</span> Read the question first, then scan passage for keywords. Focus on first and last sentences of paragraphs.
                </p>
              </div>
              <div className="bg-red-50 border-l-4 border-red-500 p-3">
                <p className="text-sm text-red-800">
                  <span className="font-semibold">Avoid:</span> Long philosophical RC passages early in paper - attempt in second round if time permits.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CSATRCPractice;
